import steps from '../survey/steps';

function events () {
	return function (next) {
		return function (action) {
			if (action.type === 'TOGGLE_LOADER' && action.payload === true) {
				steps.analytics.send({
					event: {
						event: 'funnel on onboarding',
						quiz_action: 'waiting for loader'
					}
				});
			}

			if (action.type === 'TOGGLE_RESULT_PAGE' && action.payload === true) {
				steps.analytics.send({
					event: {
						event: 'funnel on onboarding',
						quiz_action: 'view results page'
					}
				});
			}
			return next(action);
		};
	};
}

export default events;
